"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./EnterprisePromotionHero.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-387":{"id":"e-387","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-388"}},"mediaQueries":["main","medium"],"target":{"id":"6643b4b70da2ca862d7f4b91|0642671a-05d7-30f8-7310-9e6eb2de02f8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6643b4b70da2ca862d7f4b91|0642671a-05d7-30f8-7310-9e6eb2de02f8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1699387107181},"e-388":{"id":"e-388","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-387"}},"mediaQueries":["main","medium"],"target":{"id":"6643b4b70da2ca862d7f4b91|0642671a-05d7-30f8-7310-9e6eb2de02f8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6643b4b70da2ca862d7f4b91|0642671a-05d7-30f8-7310-9e6eb2de02f8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1699387107181},"e-482":{"id":"e-482","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-23","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-483"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1716505315197},"e-915":{"id":"e-915","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-916"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"71f5b900-b2d0-fc11-4d79-8f0b7a8d7bd8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"71f5b900-b2d0-fc11-4d79-8f0b7a8d7bd8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1732414615457},"e-919":{"id":"e-919","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-920"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"71f5b900-b2d0-fc11-4d79-8f0b7a8d7be0","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"71f5b900-b2d0-fc11-4d79-8f0b7a8d7be0","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1732414615457},"e-1066":{"id":"e-1066","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-1067"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"a179cc1c-9aab-31f4-61fa-d19cfd4ae621","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"a179cc1c-9aab-31f4-61fa-d19cfd4ae621","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1732664606513},"e-1068":{"id":"e-1068","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-1069"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5c11d1ca-3302-7b19-a782-ccbf19c7618b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"5c11d1ca-3302-7b19-a782-ccbf19c7618b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1732750675432},"e-1070":{"id":"e-1070","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-1071"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"881bea56-6cab-e9a1-52d1-fc63439a7c07","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"881bea56-6cab-e9a1-52d1-fc63439a7c07","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":250,"direction":"BOTTOM","effectIn":true},"createdOn":1732750701351},"e-1072":{"id":"e-1072","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-1073"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5bb06498-813b-3b5c-ae95-79c11d8fd8de","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"5bb06498-813b-3b5c-ae95-79c11d8fd8de","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":210,"direction":"BOTTOM","effectIn":true},"createdOn":1732750823752},"e-1074":{"id":"e-1074","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-1075"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"71f5b900-b2d0-fc11-4d79-8f0b7a8d7bd6","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"71f5b900-b2d0-fc11-4d79-8f0b7a8d7bd6","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":90,"direction":"BOTTOM","effectIn":true},"createdOn":1732814746595}},"actionLists":{"a-15":{"id":"a-15","title":"button-hover-icon","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small.icon-absolute","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75","5159a2aa-230f-0e59-0589-1af52a1bffef"]},"xValue":-1.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-15-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".icon-1x1-small.icon-absolute","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75","5159a2aa-230f-0e59-0589-1af52a1bffef"]},"value":0,"unit":""}},{"id":"a-15-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-15-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-15-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outBack","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small.icon-absolute","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75","5159a2aa-230f-0e59-0589-1af52a1bffef"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-15-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outBack","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-15-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":100,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small.icon-absolute","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75","5159a2aa-230f-0e59-0589-1af52a1bffef"]},"value":1,"unit":""}},{"id":"a-15-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":100,"easing":"","duration":150,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1699385442619},"a-16":{"id":"a-16","title":"button-hover-icon-out","actionItemGroups":[{"actionItems":[{"id":"a-16-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75"]},"xValue":-1.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":150,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75"]},"value":0,"unit":""}},{"id":"a-16-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"xValue":-1.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":150,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1699385442619},"a-23":{"id":"a-23","title":"skeleton-loader","actionItemGroups":[{"actionItems":[{"id":"a-23-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":-100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":1000,"easing":"","duration":800,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":250,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-23-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":-100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-23-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":800,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":250,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1716505320174},"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function EnterprisePromotionHero({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "enterprisepromotion_hero")}
      tag="section"
      grid={{
        type: "section",
      }}
      id="enterprisePromotion-hero"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "padding-global")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(
            _styles,
            "enterprisepromotion_hero_container-copy"
          )}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(
              _styles,
              "enterprisepromotion_hero-copy-wrap-copy",
              "max-width-medium"
            )}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterprisepromotion_hero-copy-subheading"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "text-size-regular",
                  "text-color-white",
                  "text-weight-bold"
                )}
                data-w-id="71f5b900-b2d0-fc11-4d79-8f0b7a8d7bd6"
                tag="div"
              >
                {"❄️ Holiday Sale ❄️ "}
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterpriseplan_hero-heading",
                "heading-style-h3",
                "text-color-white"
              )}
              data-w-id="71f5b900-b2d0-fc11-4d79-8f0b7a8d7bd8"
              tag="div"
            >
              {"Enterprise Plan: "}
              <_Builtin.Span
                className={_utils.cx(
                  _styles,
                  "enterpriseplane_hero-header-highlight"
                )}
              >
                {"Save 30%"}
              </_Builtin.Span>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterpriseplan_hero-form-content-list"
              )}
              data-w-id="71f5b900-b2d0-fc11-4d79-8f0b7a8d7be0"
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "list-item")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/672d416c1d0ecacdaf8ca972_check.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-color-white")}
                  tag="div"
                >
                  {"Bonus: No setup fee"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "list-item")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/672d416c1d0ecacdaf8ca972_check.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-color-white")}
                  tag="div"
                >
                  <_Builtin.Strong>{"50"}</_Builtin.Strong>
                  {" x Facebook Marketplace ads"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "list-item")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/672d416c1d0ecacdaf8ca972_check.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-color-white")}
                  tag="div"
                >
                  <_Builtin.Strong>{"15 "}</_Builtin.Strong>
                  {"x Tenant Screening credits"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "list-item")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/672d416c1d0ecacdaf8ca972_check.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-color-white")}
                  tag="div"
                >
                  {"Unlimited leads & listings"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "list-item")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/672d416c1d0ecacdaf8ca972_check.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-color-white")}
                  tag="div"
                >
                  {"Team management & unlimited users"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "list-item")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/672d416c1d0ecacdaf8ca972_check.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-color-white")}
                  tag="div"
                >
                  {"And more"}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterpriseplan_hero-form-description"
              )}
              data-w-id="a179cc1c-9aab-31f4-61fa-d19cfd4ae621"
              tag="div"
            >
              {"Contact us and we’ll help get you started!"}
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterprisepromotion_hero-divider",
                "hide-mobile-landscape"
              )}
              data-w-id="5c11d1ca-3302-7b19-a782-ccbf19c7618b"
              tag="div"
            />
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterprisepromotion_hero-promo-wrapper",
                "hide-mobile-landscape"
              )}
              data-w-id="881bea56-6cab-e9a1-52d1-fc63439a7c07"
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "icon-height-s-medium")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/67477b11a3f36a16c20b63e1_gift.webp"
              />
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "enterpriseplan_hero-form-description"
                )}
                tag="div"
              >
                {"Not ready for a plan? "}
                <_Builtin.Link
                  className={_utils.cx(_styles, "text-style-link-white")}
                  button={false}
                  id="bf_30offenterprise_grabtools_anchortxt_click"
                  block=""
                  options={{
                    href: "/landlords/promotions",
                  }}
                >
                  {"Grab our tools for 30% off!"}
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(
              _styles,
              "enterprisepromotion_hero-form-card-container"
            )}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterprisepromotion_hero-promos-card-discount"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "blackfriday_hero-promos-card-discount-price"
                )}
                tag="div"
              >
                {"GET 30% OFF"}
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterprisepromotion_hero-form-card"
              )}
              tag="div"
              id="zendesk-form"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "skeleton-loader")}
                tag="div"
                id="bf_zendesk_form"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "skeleton-loader-animation")}
                  tag="div"
                />
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterprisepromotion_hero-promo-text-container"
              )}
              data-w-id="5bb06498-813b-3b5c-ae95-79c11d8fd8de"
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "enterprisepromotion_hero-promo-wrapper",
                  "hide-desktop"
                )}
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "icon-1x1-s-medium")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/67477b11a3f36a16c20b63e1_gift.webp"
                />
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "enterpriseplan_hero-form-description"
                  )}
                  tag="div"
                >
                  {"Not ready for a plan? "}
                  <_Builtin.Link
                    className={_utils.cx(_styles, "text-style-link-white")}
                    button={false}
                    id="bf_30offenterprise_grabtools_anchortxt_click"
                    block=""
                    options={{
                      href: "/landlords/promotions",
                    }}
                  >
                    {"Grab our tools for 30% off!"}
                  </_Builtin.Link>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
